module.exports = __webpack_public_path__ + "static/logo-hwcid2-8ca3ffa6be2e570232adeae89cec0797.png";